export const COLUMN_NUMBER = 5
export const DESKTOP_BREAKPOINT = 920
